import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  datePickerWrapper: {
    width: '284px'
  },
  colorBox: {
    width: '120px',
    height: '120px',
    borderRadius: 2,
    margin: '5px 0',
    display: 'inline-block'
  },
  colorWrapper: {
    display: 'inline-block',
    textAlign: 'center',
    '& + &': {
      marginLeft: '20px'
    }
  },
  gradientBox: {
    width: '300px',
    height: '80px',
    borderRadius: 2,
    margin: '5px 0'
  },
  gradientDark: {
    background: palette.gradients.dark,
    width: '590px'
  },
  gradientWhite: {
    background: palette.gradients.white
  },
  gradientFade: {
    background: palette.gradients.fade
  },
  brandGradientWrapper: {
    position: 'relative',
    color: palette.shades[100]
  },
  brandGradientFrom: {
    position: 'absolute',
    left: '32px',
    top: '32px',
    color: palette.shades[100]
  },
  brandGradientTo: {
    position: 'absolute',
    top: '32px',
    right: '32px',
    color: palette.shades[100]
  },
  brandGradient: {
    height: '100px',
    width: '100%',
    borderRadius: 2
  },
  brandGradientMain: {
    background: palette.brandGradients.main
  },
  brandGradientFade: {
    background: palette.brandGradients.fade
  },
  brandSecondary: {
    background: palette.secondary.main
  },
  codeSnippet: {
    backgroundColor: palette.shades[800],
    color: palette.shades[100],
    padding: '25px 15px',
    borderRadius: 2,
    fontSize: '16px',
    overflowX: 'auto',
    lineHeight: '25px',
    whiteSpace: 'pre',
    fontFamily: 'monospace',
    margin: '16px 0',
    paddingTop: '0'
  },
  codeSnippetInline: {
    display: 'inline-block',
    marginLeft: '20px',
    padding: '10px 15px'
  },
  section: {
    padding: '32px 40px',
    marginBottom: '40px',
    borderBottom: "1px solid ".concat(palette.shades[300]),
    '& ~ &': {
      marginTop: '40px',
      borderTop: "1px solid ".concat(palette.shades[300])
    }
  },
  subsectionName: {
    borderBottom: "1px solid ".concat(palette.shades[300]),
    paddingBottom: '10px',
    marginBottom: '20px',
    '& ~ &': {
      marginTop: '20px'
    }
  },
  alertWrapper: {
    '& ~ &': {
      marginTop: '40px'
    }
  },
  iconsWrapper: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  iconWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    width: '33%'
  },
  iconStateWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    width: '50%'
  },
  hintsWrapper: {
    marginBottom: '24px'
  },
  shadowBoxWrapper: {
    margin: '40px 0'
  },
  shadowBox: {
    width: '100%',
    background: palette.shades[100],
    height: '100px'
  },
  chipsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '& div + div': {
      marginTop: '42px'
    }
  },
  utilityIcons: {
    marginTop: '24px'
  },
  utilityIcon: {
    display: 'flex',
    alignItems: 'center',
    '& + &': {
      marginTop: '10px',
      paddingTop: '10px',
      borderTop: "1px solid ".concat(palette.shades[300])
    },
    '& .MuiTypography-root': {
      marginLeft: '20px'
    }
  },
  utilityIconPlain: {
    paddingLeft: '12px',
    '& .MuiTypography-root': {
      marginLeft: '34px'
    }
  },
  billingOpt: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 0',
    '& .MuiSvgIcon-root': {
      marginRight: '10px'
    }
  },
  flexCenter: {
    display: 'flex',
    alignItems: 'center'
  }
}));
export default useStyles;